export const LOGIN = 'login';
export const LOGIN_SUCCESS = 'login_success';
export const LOGIN_FAIL = 'login_fail';
export const IS_AUTHENTICATED = 'is_authed';
export const IS_NOT_AUTHENTICATED = 'is_not_authed';
export const LOGOUT = 'logout';
export const LOGOUT_SUCCESS = 'logout_successful';
export const ACCOUNT_CREATED = 'auth/new_account_created';



// WEBPACK FOOTER //
// ./src/services/auth/actionTypes.js